import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-filter-icon',
  template: `
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18.5V16.5H14V18.5H10ZM6 13.5V11.5H18V13.5H6ZM3 8.5V6.5H21V8.5H3Z"
        fill="currentColor"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterIconComponent {}
